import config from 'config';
import WebStoragePolyfill from '../../data-providers/webstorage-polyfill';
import Analytics from '../../analytics';

export default [
  '$q', '$state', '$stateParams', '$window', '$scope',
  'CartService', 'UpsellCartService', 'username', 'campaignSlug', 'ErrorHandler',
  class AmazonCheckoutController {
    constructor($q, $state, $stateParams, $window, $scope, cartService, upsellCartService, username, slug, ErrorHandler, webstorage = new WebStoragePolyfill(), analytics = new Analytics()) {
      this._$q = $q;
      this._$state = $state;
      this._$params = $stateParams;
      this._$window = $window;
      this._$scope = $scope;
      this._errorHandler = ErrorHandler
      this._storage = webstorage;
      this.analytics = analytics;

      this.isProcessing = true;

      this.couponCode = null;

      this.addressSelected = false;
      this.paymentSelected = false;

      this.amazonReferenceId = this._$params.session;
      this.orderReferenceID = null;

      this.upsell = this._$params.upsell;
      this.upsellArray = [this._$params.upsellProduct];

      let cartPromise;
      if (this.upsell === true) {
        this.cart = upsellCartService;
        cartPromise = this._initializeAmazonWidgets()
          .then(() => this.cart.initAmazon(this.amazonReferenceId, this.orderReferenceID, this.upsellArray));
      } else {
        this.cart = cartService;
        this._initializeAmazonWidgets();
        cartPromise = this.cart.init(username, slug);
      }

      cartPromise.then((data) => {
          this.cartTotals = this.cart.getTotals();
          this.campaign = data.campaign;
        })
        .finally(() => this.isProcessing = false);
    }

    checkoutItems() {
      if (this.upsell === true) {
        return this.upsellArray;
      }

      return this.cart.contents();
    }

    processPayment() {
      this.isProcessing = true;

      if(this.upsell) {
        this.analytics.placeOrder({ option: 'Amazon', upsell: true });
      } else {
        this.analytics.placeOrder({ option: 'Amazon', upsell: false, cart: this.cart.contentsAsCampaignProducts() });
      }

      this.cart.processAmazonPaymentCart(this._$params.id, this.orderReferenceID)
        .then((res) => {
          this._storage.removeLocalItem('order-credentials');
          this._storage.setLocalItem('order-credentials', `${res.order_id}:${res.zip_code}`);
          this._$window.location.href = '/purchase/thank-you';
        })
        .catch((res) => {
          this._errorHandler.throwError('Payment Processing', res && res.message ? res.message : 'Error processing Amazon payment.');
          this.isProcessing = false;
        });
    }

    goBack() {
      this._$window.history.back();
    }

    _initializeAmazonWidgets() {
      let initDeferred = this._$q.defer();

      new OffAmazonPayments.Widgets.AddressBook({
        sellerId: config['Amazon']['sellerID'],
        design: {
          designMode: 'responsive'
        },
        onOrderReferenceCreate: (orderRef) => {
          this.orderReferenceID = orderRef.getAmazonOrderReferenceId();
          initDeferred.resolve();
        },
        onAddressSelect: () => {
          this.addressSelected = true;
          this.cart.getAmazonTotals(this.amazonReferenceId, this.orderReferenceID);
        },
        onError: (error) => {
          this._errorHandler.logError('Amazon Address Error', `${error.getErrorCode()} - ${error.getErrorMessage()}`, error);
          this._$window.location.href = this._$params.csl;
        }
      }).bind('amazon_address_book');

      new OffAmazonPayments.Widgets.Wallet({
        sellerId: config['Amazon']['sellerID'],
        design: {
          designMode: 'responsive'
        },
        onPaymentSelect: () => this.paymentSelected = true,
        onError: (error) => {
          this._errorHandler.logError('Amazon Wallet Error', `${error.getErrorCode()} - ${error.getErrorMessage()}`, error);
          this._$window.location.href = this._$params.csl;
        }
      }).bind("amazon_wallet_widget");

      return initDeferred.promise;
    }
  }
];


// WEBPACK FOOTER //
// ./source/client/pages/amazon-checkout/amazon-checkout.ctrl.js